import React from 'react';
import DocumentVaultBlock from './DocumentVaultBlock';

const DocumentVault = () => {
  return <DocumentVaultBlock />;
};

export default DocumentVault;
